import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorInterceptor } from './core/services/error.interceptor';
import { HeaderInterceptor } from './core/services/header.interceptor';

import { SharedModule } from './shared/shared.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import localeEsAr from '@angular/common/locales/es-AR';
import { DatePipe, registerLocaleData } from '@angular/common';
import { EnabledPipe } from './shared/pipes/enabled.pipe';
import {
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
	MsalBroadcastService,
	MsalGuard,
	MsalInterceptor,
	MsalModule,
	MsalRedirectComponent,
	MsalService
} from '@azure/msal-angular';
import {
	MSALGuardConfigFactory,
	MSALInstanceFactory,
	MSALInterceptorConfigFactory
} from './modules/authentication/auth-config';
import { AuthenticationModule } from './modules/authentication/authentication.module';
import {
	MAT_PAGINATOR_DEFAULT_OPTIONS,
	MatPaginatorDefaultOptions
} from '@angular/material/paginator';
import { YesNoPipe } from './shared/pipes/yes-no.pipe';
import { DynamicPropertyPipe } from './shared/pipes/dynamic-property.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { provideLucideIcons } from './shared/providers/lucide-angular-module.provider';

registerLocaleData(localeEsAr, 'es-Ar');

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		AuthenticationModule,
		MsalModule,
		SharedModule,
		FontAwesomeModule
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HeaderInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true
		},
		{ provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true
		},
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory
		},
		{
			provide: MSAL_GUARD_CONFIG,
			useFactory: MSALGuardConfigFactory
		},
		{
			provide: MSAL_INTERCEPTOR_CONFIG,
			useFactory: MSALInterceptorConfigFactory
		},
		{
			provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
			useValue: { hidePageSize: true } as MatPaginatorDefaultOptions
		},
		{ provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { autoFocus: false } },
		provideHttpClient(withInterceptorsFromDi()),
		MsalService,
		MsalGuard,
		MsalBroadcastService,
		DatePipe,
		EnabledPipe,
		YesNoPipe,
		DynamicPropertyPipe,
		provideLucideIcons()
	],
	bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {}
